/**
 * RequireFeature (TL-051): a layout route that renders its children only when
 * the tenant has the feature on. Otherwise it sends the visitor home.
 *
 *   <Route element={<RequireFeature name="careers" />}>
 *     <Route path={ROUTES.CAREERS} element={<CareersPage />} />
 *   </Route>
 */

import { Navigate, Outlet } from "react-router-dom";

import type { FeatureName } from "@/lib/api/tenant";
import { useFeature } from "@/lib/tenant";
import { ROUTES } from "@/types/routes";

export function RequireFeature({ name }: { name: FeatureName }) {
  const on = useFeature(name);
  return on ? <Outlet /> : <Navigate to={ROUTES.HOME} replace />;
}
